import React, { useEffect, useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Button, NamedLink } from '..'
import moment from 'moment';
import css from './StripeSubscriptionPanel.module.css';
import {PROFESSIONAL_ANNUALY, PROFESSIONAL_MONTHLY } from '../../util/types';
import { useDispatch } from 'react-redux';

function SubscriptionCustomCard(props) {
  const dispatch = useDispatch();
  const { 
    plan,
    handleSubscription,
    createSubscriptionInProgress,
    setCardPaymentModal,
    currentUser,
    isActive,
    currentSubscription
  } = props;
  
  const paymentButtonDisabled = currentSubscription ||
    (moment().unix() > (currentSubscription?.current_period_end)) 

  const isUserHasPaymentId = currentUser && !!currentUser?.stripeCustomer?.defaultPaymentMethod?.attributes?.stripePaymentMethodId;
  return (
    <div className={css.card} >
      {plan &&
        <div className={css.professionalCardHeading}>
          <div className={css.cardPlanHeading}>
           Unlock the benefits of Pro Stars today
          </div>
        </div>}

      <h2 className={css.subscriptionPrice}>
        Just {'$' + (plan?.unit_amount) / 100}/month - Cancel Anytime 
      </h2>
      {!isActive ? (
        <div className={css.upgradeDownGradeButton}>
          <Button
            onClick={(e) => {
              if (isUserHasPaymentId) {
                handleSubscription(e, plan);
              } else {
                setCardPaymentModal(plan);
              }
            }}
            // disabled={paymentButtonDisabled}
            inProgress={createSubscriptionInProgress == plan?.id}
          >
            <FormattedMessage id="SubscriptionCustomCard.paidPlanButtonText" />
          </Button>
        </div>
      ) : (
        <div className={css.upgradeDownGradeButton}>
          <NamedLink name="ManageSubscriptionPage">
            View Subscription
          </NamedLink>
        </div>
      )}

    </div>
  )
}

export default SubscriptionCustomCard